import { useQuery } from "@tanstack/react-query";
import { getTransactions, downloadInvoice, getAllTransactionsForKPI } from "./api";
import { IPaginatedTransaction, ITransaction } from "./types";

export const transactionsKeys = {
  root: ["transactions"] as const,
  list: (page: number) => [...transactionsKeys.root, "list", page] as const,
  kpi: () => [...transactionsKeys.root, "kpi"] as const,
};

export function useTransactions(page: number) {
  return useQuery<IPaginatedTransaction<ITransaction>>({
    queryKey: transactionsKeys.list(page),
    queryFn: () => getTransactions(page),
    placeholderData: (prev) => prev,
    staleTime: 30_000,
  });
}

export function useTransactionsKPI() {
  return useQuery({
    queryKey: transactionsKeys.kpi(),
    queryFn: getAllTransactionsForKPI,
    staleTime: 60_000, // Cache for 1 minute
  });
}

export { downloadInvoice };
